module.exports = __webpack_public_path__ + "assets/img/icon06.d7a9fb13.png";